import React from "react";
import styled from "styled-components";
import { SlLike } from "react-icons/sl";
import { BsReply } from "react-icons/bs";
import { AiOutlineRetweet } from "react-icons/ai";
import { RxShare2, RxHamburgerMenu } from "react-icons/rx";

function Card(props) {
  return (
    <Chirp>
      <div className="profile-pic">
        <img src={props.profilePic} width="50" alt="profile pic" />
      </div>
      <div className="user-name">
        <span className="bold">{props.profileName}</span>&nbsp; &middot; &nbsp;
        {props.profileHandle}&nbsp; &middot; &nbsp;{props.postDate}
      </div>
      <div className="hamburger">
        <RxHamburgerMenu />
      </div>
      <h2 className="title bold">{props.title}</h2>
      <div></div>
      <div className="the-chirp">
        <p>{props.textContent}</p>
        <iframe
          width="560"
          height="315"
          src={props.videoUrl}
          title="YouTube video player"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; fullscreen; picture-in-picture"
        ></iframe>
      </div>
      <div></div>
      <div className="like-etc">
        <SlLike />
        <BsReply />
        <AiOutlineRetweet />
        <RxShare2 />
      </div>
    </Chirp>
  );
}

const Chirp = styled.div`
  display: grid;
  text-align: left;
  grid-template-columns: 100px auto 50px;
  grid-template-rows: auto auto auto auto;
  max-width: 700px;
  width: 90%;
  border: 1pxm solid black;
  box-shadow: 0 1px 3px 0 rgb(0 0 0 / 10%), 0 5px 25px 0 rgb(50 85 115 / 15%);
  border-radius: 10px;
  color: #404040;
  font-size: 1rem;
  font-family: "Libre Franklin", sans-serif;
  background-color: #fff;
  grid-row-gap: 2px;
  margin-bottom: 20px;

  h2 {
    margin: 0;
    padding: 0;
    font-size: 1rem;
  }

  .bold {
    font-weight: 700;
  }

  .profile-pic {
    cursor: pointer;
    grid-row: 1/5;
    align-self: top;
    justify-self: center;
  }

  .profile-pic > img {
    padding-top: 5px;
    border-radius: 50%;
  }

  .user-name {
    color: #aaa;
    padding-bottom: 5px;
    padding-top: 5px;
    cursor: pointer;
  }

  .user-name:hover {
    text-decoration: underline;
  }

  .hamburger {
    padding-top: 10px;
    padding-left: 10px;
    cursor: pointer;
  }

  .title {
    padding-bottom: 5px;
    cursor: pointer;
  }

  .the-chirp {
    margin-block: 0;
  }

  .the-chirp > iframe {
    border-radius: 10px;
  }

  .the-chirp > p {
    margin-top: 0px;
  }

  .like-etc {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr;
    cursor: pointer;
    padding-block: 8px;
  }
`;

export default Card;
